module.exports = __webpack_public_path__ + "img/dim.672aa3cd.png";